module.exports = "/build/images/GarbageButton.svg?dd496e1175bddf2473114d4037e004a8";


//////////////////
// WEBPACK FOOTER
// ./yii2/frontend/frontend-assets/src/_static/images/GarbageButton.svg
// module id = 2423
// module chunks = 0